<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title class="mb-sm-0 mb-1">
        {{ radialBarChart.title }}
      </b-card-title>
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="radialBar"
        height="250"
        :options="radialBarChart.chartOptions"
        :series="radialBarChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardTitle, BCardBody, BCardHeader } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardBody,
    BCardHeader,
  },
  props: {
    radialBarChart: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
